import React, { useState } from 'react';
import { ModalBody, Text, ModalFooter, Button, Alert, Flex } from '@spothero/ui';
import { ClockPlus as MoreTime } from '@spothero/icons';
import NewTimesDisplay from '../new-times-display';
import { updateReservationTimes } from 'store/parking-pass/parking-pass-actions';
import { useDispatch } from 'react-redux';
import dayjs from 'utils/dayjs-timezone';
const ChangeTimesNoCharge = ({ onCloseModal, handleBackToTimeSelect, rateDiff, timezone, isAutoExtension, reservation, onSuccess, setIsSubmitting, isSubmitting, onError, }) => {
    const dispatch = useDispatch();
    const [isError, setIsError] = useState(false);
    const onSubmit = async () => {
        setIsSubmitting(true);
        setIsError(false);
        // If auto extensions led to the times not changing, just close the modal and show success message
        if (reservation.starts.isSame(dayjs(rateDiff.starts).tz(reservation.timezone)) &&
            reservation.ends.isSame(dayjs(rateDiff.ends).tz(reservation.timezone))) {
            onSuccess();
            return;
        }
        const response = await dispatch(updateReservationTimes({
            reservationId: reservation.rentalId,
            rateDiff,
            timezone,
        }));
        // @ts-expect-error
        if (response.success) {
            onSuccess();
        }
        else {
            // @ts-expect-error
            onError(response.error);
            setIsError(true);
        }
    };
    return (<>
            <ModalBody flexDirection="column" data-testid="ChangeTimesNoCharge">
                {isAutoExtension && (<Alert marginBottom={6} showIcon icon={MoreTime} status="neutral" description="You're getting more time than you selected at no additional cost. Happy parking!"/>)}
                <NewTimesDisplay rateDiff={rateDiff} timezone={timezone} handleBackToTimeSelect={handleBackToTimeSelect}/>
                <Flex marginTop={4} flexDirection="column">
                    <Text fontWeight="semibold" fontSize="sm" color="text.secondary.light">
                        Payment Amount
                    </Text>
                    <Text>$0.00 (this one&apos;s on us!)</Text>
                </Flex>
                {isError && (<Alert title="Oops, we hit a snag changing your reservation." description="Please try again." showIcon status="error" size="md" marginBottom={4} marginTop={4}/>)}
            </ModalBody>
            <ModalFooter justifyContent="end" gap={4} flexDirection={{ base: 'column', desktop: 'row-reverse' }}>
                <Button loadingText={'Update Reservation'} data-testid="ChangeTimesNoCharge-update-reservation-button" width={{ base: '100%', desktop: 'auto' }} onClick={onSubmit} disabled={isSubmitting}>
                    Update Reservation
                </Button>
                <Button width={{ base: '100%', desktop: 'auto' }} onClick={() => onCloseModal()} variant="secondary">
                    Cancel
                </Button>
            </ModalFooter>
        </>);
};
export default ChangeTimesNoCharge;
